import { defineMessages } from "react-intl";

export const navLabels = defineMessages({
  dashboard: {
    id: "8PxJ3W",
    defaultMessage: "Insights",
    description: "Dashboard/Insights nav item",
  },
  posture: {
    id: "bqt9Wb",
    defaultMessage: "Posture",
    description: "Posture group nav item",
  },
  lifecycle: {
    id: "2HJZ0S",
    defaultMessage: "Governance",
    description: "Governance (Lifecycle) group nav item",
  },
  protect: {
    id: "UcnUyX",
    defaultMessage: "Access",
    description: "Access group nav item (Access Gateway + Runtime Auth)",
  },
  agents: {
    id: "KCGP41",
    defaultMessage: "Agents",
    description: "Agents nav item under Lifecycle",
  },
  "non-human": {
    id: "U+FZO4",
    defaultMessage: "Non-Human",
    description: "Non-Human nav item under Lifecycle",
  },
  "access-gateway": {
    id: "tUR/7R",
    defaultMessage: "Access Gateway",
    description: "Access Gateway nav item",
  },
  "agent-runtime-authz": {
    id: "jSQc4F",
    defaultMessage: "Runtime Authorization",
    description: "Agent Runtime Authz nav item",
  },
  identities: {
    id: "H4FWJD",
    defaultMessage: "Inventory",
    description: "Inventory (Identities) nav item",
  },
  integrations: {
    id: "/KTPUS",
    defaultMessage: "Integrations",
    description: "Integrations nav item",
  },
  policies: {
    id: "0g6P9y",
    defaultMessage: "Policies",
    description: "Policies nav item",
  },
  agent: {
    id: "d3Duyd",
    defaultMessage: "Agent",
    description: "Agent nav item",
  },
  admin: {
    id: "VkJHPL",
    defaultMessage: "Admin",
    description: "Admin nav item",
  },
  "ispm-users": {
    id: "Zsn6wk",
    defaultMessage: "Users",
    description: "Users sub-nav item",
  },
  settings: {
    id: "031hPF",
    defaultMessage: "Settings",
    description: "Settings sub-nav item",
  },
  "sso-settings": {
    id: "CGGOy8",
    defaultMessage: "SSO Settings",
    description: "SSO Settings sub-nav item under Settings",
  },
  "audit-trail": {
    id: "3SPXA0",
    defaultMessage: "Audit Trail",
    description: "Audit Trail sub-nav item under Admin",
  },
});
